module.exports = __webpack_public_path__ + "img/widget-whastapp.ec0a9ff7.png";